import React, { useState } from "react"

import { useForm } from "@/pages/hooks/useForm"
import { QuestionForm } from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/CreateQuestionModal"
import { Checkbox, UnstyledButton } from "@/components"
import classes from "@/pages/campaign-form/components/campaigns/personalizedMessages/components/CustomQuestions/BooleanValue.module.css"

interface Props {
    questionForm: ReturnType<typeof useForm<QuestionForm>>
}

export const BooleanValue = ({ questionForm }: Props) => {
    const handleChange = (value: boolean | null) => {
        questionForm.setFieldValue("default_boolean_value", value)
    }

    return (
        <div className={classes.defaultValue}>
            <UnstyledButton
                role="checkbox"
                className={classes.booleanOption}
                onClick={() => handleChange(questionForm.values.default_boolean_value === true ? null : true)}
            >
                <span className={classes.optionLabel}>Yes</span>
                <Checkbox checked={questionForm.values.default_boolean_value} label="Default" />
            </UnstyledButton>
            <UnstyledButton
                role="checkbox"
                className={classes.booleanOption}
                onClick={() => handleChange(questionForm.values.default_boolean_value === false ? null : false)}
            >
                <span className={classes.optionLabel}>No</span>
                <Checkbox checked={questionForm.values.default_boolean_value === false} label="Default" />
            </UnstyledButton>
        </div>
    )
}
